module.exports = __webpack_public_path__ + "static/media/signwithmobile.1d2df336.svg";